import { useQueryClient } from '@tanstack/react-query';

import { queryKeys } from 'api/config';

import { SessionMetadataResponse } from 'features/sessions/config/types';

export const useSessionsMetadataQueryActions = () => {
  const queryClient = useQueryClient();

  const getInsightStructure = () => {
    const data = queryClient.getQueryData<SessionMetadataResponse>([
      queryKeys.coachSessionMetadata,
    ]);

    return data?.transcriptInsightsStructure || [];
  };

  const getMetadata = () =>
    queryClient.getQueryData<SessionMetadataResponse>([
      queryKeys.coachSessionMetadata,
    ]);

  const getInsightStructureByCode = (code: string) => {
    const metadata = queryClient.getQueryData<SessionMetadataResponse>([
      queryKeys.coachSessionMetadata,
    ]);

    return metadata?.transcriptInsightsStructure.find(
      (structure) => structure.code === code
    );
  };

  const setMetadata = (metadata: SessionMetadataResponse) => {
    queryClient.setQueryData<SessionMetadataResponse>(
      [queryKeys.coachSessionMetadata],
      metadata
    );
  };

  const invalidateMetadataQuery = () => {
    queryClient.invalidateQueries([queryKeys.coachSessionMetadata]);
  };

  return {
    setMetadata,
    getMetadata,
    getInsightStructure,
    getInsightStructureByCode,
    invalidateMetadataQuery,
  };
};
